<template>
    <div class="news-and-press-list section grid">
        <!-- <pre v-text="content"></pre> -->

        <span class="news-and-press-list--empty-message" v-if="!filteredArticles.length"
                v-text="content.no_article_label">
        </span>

        <div class="grid--row news-and-press--mobile-filter">
            <div class="grid--col news-and-press--mobile-filter-col">
                <cmp-dropdown-filter></cmp-dropdown-filter>
            </div>
        </div>

        <div class="news-and-press-list--articles">
            <cmp-news-and-press-item class="news-and-press-list--article"
                    v-for="(article, articleIdx) in filteredArticles" :key="articleIdx"
                    :article="article"
                    :article-type-label="articleTypeLabel(article)">
            </cmp-news-and-press-item>
        </div>

        <div class="news-and-press-list--more" v-if="showMoreBtn">
            <button type="button" class="news-and-press-list--more-btn"
                    @click.prevent="onMoreRequested($event)">
                <span class="news-and-press-list--more-text">Mehr anzeigen</span>
                <cmp-icon class="news-and-press-list--more-icon"
                        symbol="chevron_down"
                        size="x-small">
                </cmp-icon>
            </button>
            <span class="news-and-press-list--load-error general-error" v-if="loadError" v-text="loadError"></span>
        </div>
    </div>
</template>

<script>
    import Axios from 'util/service';
    import { countBy, get } from 'lodash';
    import { mapActions, mapGetters } from 'vuex';
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [cmsPlugin],
        data() {
            return {
                loadError: '',
            };
        },
        computed: {
            ...mapGetters(['filter']),
            filterKeywords() {
                return get(this, 'content.article_filter.keywords', {});
            },
            numArticles() {
                const result = countBy(this.content.article_list, (article) => {
                    return article.article_type;
                });
                result[this.content.article_filter.keywords.all] = this.content.article_list.length;

                return result[this.filter.val];
            },
            filteredArticles() {
                return this.content.article_list
                    .filter(article => {
                        return [article.article_type, this.filterKeywords.all].includes(this.filter.val);
                    })
                    .sort((a, b) => {
                        return b.timestamp - a.timestamp;
                    });
            },
            showMoreBtn() {
                return this.filteredArticles.length < this.content.article_amount[this.filter.val];
            },
        },
        methods: {
            ...mapActions(['setFilterData', 'setFilterValue']),
            articleTypeLabel(article) {
                const filter = this.filter.items.find(type => type.val === article.article_type);
                return filter.label || filter.val;
            },
            onMoreRequested() {
                const startPos = this.filteredArticles.length;
                this.loadMoreArticles({
                    start: startPos,
                    end: startPos + this.content.pagination_amount,
                    type: this.filter.val,
                });
            },
            loadMoreArticles(params) {
                Axios
                    .get(this.content.url, { params }, {
                        validateStatus: function(status) {
                            return status === 200;
                        },
                    })
                    .then(
                        ({ data }) => {
                            this.loadError = '';
                            this.content.article_list.push(...data.article_list);
                        },
                        ({ response }) => {
                            this.loadError = `${ response.status } - ${ response.statusText }`;
                        }
                    );
            },
        },
        watch: {
            'content.article_filter': {
                handler(val) {
                    if (!val) {
                        return;
                    }

                    this.setFilterData(val);
                },
                immediate: true,
            },
            'filter.val': {
                handler(val) {
                    if (!val) {
                        return;
                    }

                    const hasLessThanInitial = this.filteredArticles.length < this.content.initial_amount;
                    const hasAvailable = this.content.article_amount[val] > this.filteredArticles.length;

                    if (hasAvailable && hasLessThanInitial) {
                        this.loadMoreArticles({
                            start: this.filteredArticles.length,
                            end: this.content.initial_amount,
                            type: this.filter.val,
                        });
                    }
                },
                immediate: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?f5b7948e